(function () {
  var sizeMaps = {
    "US(M)": {
      XXS: "XXS",
      XS: "XS",
      S: "S",
      M: "M",
      L: "L",
      XL: "XL",
      "2XL": "2XL",
      "3XL": "3XL",
      "4XL": "4XL",
      "5XL": "5XL",
      "6XL": "6XL"
    },
    "US(W)": {
      XXS: "XS",
      XS: "S",
      S: "M",
      M: "L",
      L: "XL",
      XL: "2XL",
      "2XL": "3XL",
      "3XL": "4XL",
      "4XL": "5XL",
      "5XL": "6XL",
      "6XL": "7XL"
    },
    EU: {
      XXS: "42",
      XS: "44",
      S: "46",
      M: "48",
      L: "50",
      XL: "52",
      "2XL": "54",
      "3XL": "56",
      "4XL": "58",
      "5XL": "60",
      "6XL": "62"
    },
    UK: {
      XXS: "XXS",
      XS: "XS",
      S: "S",
      M: "M",
      L: "L",
      XL: "XL",
      "2XL": "2XL",
      "3XL": "3XL",
      "4XL": "4XL",
      "5XL": "5XL",
      "6XL": "6XL"
    }
  };

  function normalizeSize(size) {
    return String(size || "").trim().toUpperCase().replace(/\s+/g, "");
  }

  function convertSize(baseSize, sizeType) {
    var normalizedSize = normalizeSize(baseSize);
    var typeMap = sizeMaps[sizeType] || sizeMaps["US(M)"];
    return typeMap[normalizedSize] || baseSize;
  }

  function getSizeTargets(scope) {
    var sizeOption = scope.querySelector(".jerseerium-new-pdp-size-option");
    if (!sizeOption) return [];

    return Array.prototype.slice.call(
      sizeOption.querySelectorAll(".m-product-option--node__label, select option:not([disabled])")
    );
  }

  function updateSizeLabels(scope, sizeType) {
    getSizeTargets(scope).forEach(function (target) {
      if (!target.dataset.jerseeriumBaseSize) {
        target.dataset.jerseeriumBaseSize = target.textContent.trim();
      }

      target.textContent = convertSize(target.dataset.jerseeriumBaseSize, sizeType);
    });
  }

  function initSizeTypePicker(picker) {
    if (picker.dataset.jerseeriumSizeTypeReady === "true") return;
    picker.dataset.jerseeriumSizeTypeReady = "true";

    var scope = picker.closest(".m-product-info--wrapper") || document;
    var buttons = Array.prototype.slice.call(picker.querySelectorAll("[data-jerseerium-size-type-value]"));
    var input = picker.querySelector("[data-jerseerium-size-type-input]");

    function setSizeType(sizeType) {
      buttons.forEach(function (button) {
        button.setAttribute("aria-pressed", button.dataset.jerseeriumSizeTypeValue === sizeType ? "true" : "false");
      });

      if (input) input.value = sizeType;
      updateSizeLabels(scope, sizeType);
    }

    buttons.forEach(function (button) {
      button.addEventListener("click", function () {
        setSizeType(button.dataset.jerseeriumSizeTypeValue);
      });
    });

    var activeButton = buttons.find(function (button) {
      return button.getAttribute("aria-pressed") === "true";
    });

    setSizeType(activeButton ? activeButton.dataset.jerseeriumSizeTypeValue : "US(M)");
  }

  function initSizeGuideTrigger(trigger) {
    if (trigger.dataset.jerseeriumSizeGuideReady === "true") return;

    var modalId = trigger.getAttribute("aria-controls");
    var modal = modalId ? document.getElementById(modalId) : null;
    if (!modal) return;

    trigger.dataset.jerseeriumSizeGuideReady = "true";

    function openModal(event) {
      if (event) event.preventDefault();
      modal.hidden = false;
      trigger.setAttribute("aria-expanded", "true");
      document.body.classList.add("jerseerium-size-guide-open");

      var closeButton = modal.querySelector("[data-jerseerium-size-guide-close]");
      if (closeButton) closeButton.focus();
    }

    function closeModal(event) {
      if (event) event.preventDefault();
      modal.hidden = true;
      trigger.setAttribute("aria-expanded", "false");
      document.body.classList.remove("jerseerium-size-guide-open");
      trigger.focus();
    }

    trigger.addEventListener("click", openModal);

    Array.prototype.slice.call(modal.querySelectorAll("[data-jerseerium-size-guide-close]")).forEach(function (button) {
      button.addEventListener("click", closeModal);
    });

    modal.addEventListener("click", function (event) {
      if (event.target === modal) closeModal(event);
    });

    document.addEventListener("keydown", function (event) {
      if (!modal.hidden && event.key === "Escape") closeModal(event);
    });
  }

  function init(root) {
    if (!document.body.classList.contains("new-product-page")) return;

    Array.prototype.slice.call((root || document).querySelectorAll("[data-jerseerium-size-type]")).forEach(
      initSizeTypePicker
    );

    Array.prototype.slice.call((root || document).querySelectorAll("[data-jerseerium-size-guide-trigger]")).forEach(
      initSizeGuideTrigger
    );
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    init(event.target);
  });
})();
